module.exports = __webpack_public_path__ + "static/1-1801cac6699dc176457e0fec0b26d312.png";